import type { IconNode } from '../types';

/**
 * @name stairs-arch
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjEgMjFIM1YxMWE5IDkgMCAxIDEgMTggMFoiIC8+CiAgPHBhdGggZD0iTTIwLjc3IDlIMTJ2NCIgLz4KICA8cGF0aCBkPSJNOCAxN3YtNGgxMyIgLz4KICA8cGF0aCBkPSJNMyAxN2gxOCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/stairs-arch
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const stairsArch: IconNode = [
  ['path', { d: 'M21 21H3V11a9 9 0 1 1 18 0Z', key: '1ctdit' }],
  ['path', { d: 'M20.77 9H12v4', key: 'jxc5yj' }],
  ['path', { d: 'M8 17v-4h13', key: 'z8ctgs' }],
  ['path', { d: 'M3 17h18', key: '3xqu03' }],
];

export default stairsArch;
